import React from 'react';
import PropTypes from 'prop-types';
import usePercentage from '../../../hooks/usePercentage';


function TaxRate({taxRate}) {

    const percentage = usePercentage(taxRate);

    return percentage;
}


TaxRate.propTypes = {
    taxRate: PropTypes.number.isRequired
};

TaxRate.defaultProps = {};


export default TaxRate;
